import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/ItemPublish/Get`, payload),
    GetMobile: (payload) => Repository.post(`/api/ItemPublish/GetMobile`, payload),
    GetDetail: (payload) => Repository.post(`/api/ItemPublish/GetDetail`, payload),
}
